document.querySelectorAll('.readmore').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.test2').forEach(function(el) {
            el.style.display = 'block';
        });
        document.querySelectorAll('.readmore').forEach(function(el) {
            el.style.display = 'none';
        });
        document.querySelectorAll('.readless').forEach(function(el) {
            el.style.display = 'block';
        });
    });
});

document.querySelectorAll('.readless').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('.test2').forEach(function(el) {
            el.style.display = 'none';
        });
        document.querySelectorAll('.readmore').forEach(function(el) {
            el.style.display = 'block';
        });
        document.querySelectorAll('.readless').forEach(function(el) {
            el.style.display = 'none';
        });
    });
});

var tab = document.querySelectorAll(".tab");
               tab.forEach(function(ques) {
            var btn = ques.querySelector(".tab-toggle");
            btn.addEventListener("click", function () {
                tab.forEach(function (closed) {
                    if (closed !== ques) {
                        closed.classList.remove("show-item");}  });
                ques.classList.toggle("show-item"); });});


const login= document.querySelector(".btn_login")
 const close= document.querySelector(".btn-close")
 if(login){
     login.addEventListener("click",function(){
    document.querySelector(".pop-up").classList.add("active")
       
});
 }
if(close){
close.addEventListener("click",function(){
    document.querySelector(".pop-up").classList.remove("active")
    
});
}

  window.addEventListener('DOMContentLoaded', function() {
    var limitChar = 33;
    var productTitles = document.querySelectorAll('.productitem--title');
    
    if (productTitles.length > 0) {
        productTitles.forEach(function(title) {
            var link = title.querySelector('a');
            var text = link.textContent.trim();
            
            if (text.length > limitChar) {
                text = text.substr(0, limitChar) + '...';
                link.textContent = text;
            }
        });
    }
});


 // Add item field in bulk order page 
var element = document.querySelector(".btnmore");
var id = 0;

if (element) {
  element.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent form submission
    addMoreFields();
  });

  function addMoreFields() {
    // Remove previous message if it exists
    var oldMsg = document.querySelector(".max-limit-message");
    if (oldMsg) oldMsg.remove();
  
    var totalRows = document.querySelectorAll(".item_container_add .form-fields-columns").length;

    if (totalRows < 6) {
      id++;
      var Element = document.querySelector(".item_container_add");   
      var wrapper = document.createElement("div");
      wrapper.className = "form-fields-columns";
      wrapper.setAttribute("data-id", id);

      wrapper.style.display = "flex";
      wrapper.style.alignItems = "center";
      wrapper.style.gap = "10px";
      wrapper.style.marginBottom = "10px";

      // Add inner HTML
      wrapper.innerHTML = `
        <div class="form-field form-field--half" id="dropdown" style="flex:1;">
          <label for="Item-${id}" class="form-field-title">What do you require?</label>
          <select id="user_requirement-${id}" name="contact[Item-${id}]" class="form-field-input form-field-text">
            <option>Chairs</option>
            <option>Desks</option>
            <option>Storage</option>
            <option>Lockers</option>
            <option>Accessories</option>
            <option>All of the Above</option>
            <option>Other</option>
          </select>
        </div>

        <div class="form-field form-field--half" id="quant" style="flex:1;">
          <label for="Quantity-${id}" class="form-field-title">Quantity</label>
          <select id="user_quantity-${id}" name="contact[Quantity-${id}]" class="form-field-input form-field-text">
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6+</option>
          </select>
        </div>

        <button type="button" class="remove-item" style="
          background-color: #d00b00;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 4px;
          cursor: pointer;
          height: 100%;
          margin-bottom: 1.171875rem;
          align-self: center;
        "> <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="20" height="20">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 4h6m-7 0a2 2 0 012-2h4a2 2 0 012 2m-7 0h8" />
</svg>
</button>
      `;

      // Append the new row
      Element.appendChild(wrapper);
    } else {
      // Show message below the Add More button
      var message = document.createElement("p");
      message.className = "max-limit-message";
      message.textContent = "You can add a maximum of 6 items only.";
      message.style.color = "red";
      message.style.marginTop = "8px";
      message.style.fontSize = "14px";
      message.style.paddingLeft="15px";
      element.insertAdjacentElement("afterend", message);
    }
  }

  // Event delegation for Remove button
document.addEventListener("click", function (event) {
  const button = event.target.closest(".remove-item");
  if (button) {
    event.preventDefault();
    const row = button.closest(".form-fields-columns");
    if (row) row.remove();
  }
});
}




document.querySelectorAll('.options-selection__input-select-wrapper').forEach(function(input) {
    input.addEventListener('change', function() {
        var cust_price_element = document.querySelector('.product-pricing .price__current .money');
        var cust_price = parseFloat(cust_price_element.textContent.replace(/[^0-9\.-]+/g,""));
        var install_price = "$" + (cust_price / 4);
        document.querySelector('.payment-4-installment p b .h2').innerHTML = install_price;
    });
});


window.openTab = function (evt, tabName) {
    // Hide all tab content
    var tabContent = document.getElementsByClassName("meta-tab");
    for (var i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
    }

    // Remove "active" class from all tab buttons
    var tabLinks = document.getElementsByClassName("tab-link");
    for (var i = 0; i < tabLinks.length; i++) {
        tabLinks[i].classList.remove("active");
    }

    // Show selected tab & mark button as active
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.classList.add("active");
};

// Run after DOM loads
document.addEventListener("DOMContentLoaded", function () {
    var defaultTab = document.querySelector(".tab-link.active");
    var firstTab = document.querySelector(".tab-link");

    if (defaultTab) {
        defaultTab.click();
    } else if (firstTab) {
        firstTab.click();
    }
});

// To hide the alert when varient shows error 
document.addEventListener("DOMContentLoaded", function () {
   const alertHide = document.querySelector(".message-banner--container");
   const varientSection = document.getElementById("product-options-ho4ed2r6cwo");       
      if (varientSection) {
        alertHide.style.display = "none"; 
      }   
  });
